export default {
  FUNDRAISING: 'fundraising',
  CAMPAIGN: 'campaign',
  TEAM: 'team',
  UNKNOWN: 'unknown',
};
